
import React from 'react';
import AnimatedSection from '../../../components/base/AnimatedSection';

const TransformationSection = () => {
  return (
    <AnimatedSection className="py-20 px-6 bg-gradient-to-br from-[#394851] to-[#748881] text-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-6">
            The transformation you've been waiting for
          </h2>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed">
            Within 2-3 weeks of working together, you'll see movement. Within 1-2 months, everything changes.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-3xl font-semibold mb-8 text-[#A8AE9C]">
              Here's what actually happens:
            </h3>
            
            <div className="space-y-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#A8AE9C] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-[#394851] font-bold">1</span>
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-3">
                    Week 2-3: You see movement
                  </h4>
                  <p className="text-gray-200 leading-relaxed">
                    Your phone starts ringing more. Website inquiries increase. People start using your actual words when they call. 
                    You feel the shift—finally, someone understands what you do.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#A8AE9C] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-[#394851] font-bold">2</span>
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-3">
                    Month 1-2: Profits accelerate by 30%
                  </h4>
                  <p className="text-gray-200 leading-relaxed">
                    Not just more customers—better customers. People who understand your value and don't haggle on price. 
                    Your profit margins improve because you're attracting the right people.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#A8AE9C] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-[#394851] font-bold">3</span>
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-3">
                    Month 3+: Premium clients reach out
                  </h4>
                  <p className="text-gray-200 leading-relaxed">
                    The customers you've always wanted start finding you. They come pre-sold, ready to pay premium prices 
                    because your words finally reflect the quality of your work.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#A8AE9C] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-[#394851] font-bold">4</span>
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-3">
                    Long-term: Your business becomes your legacy
                  </h4>
                  <p className="text-gray-200 leading-relaxed">
                    Not just another struggling operation, but the business you always intended. 
                    Something you're proud to pass down. Something that serves your community the way it deserves.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 border border-white/20">
            <h3 className="text-2xl font-semibold mb-6 text-[#A8AE9C]">
              But more importantly...
            </h3>
            
            <div className="space-y-6">
              <div className="bg-white/5 rounded-lg p-6">
                <h4 className="text-lg font-semibold mb-3">You feel the relief</h4>
                <p className="text-gray-200">
                  Of finally being understood by someone who can translate that understanding into words that move people.
                </p>
              </div>

              <div className="bg-white/5 rounded-lg p-6">
                <h4 className="text-lg font-semibold mb-3">You stop wasting money</h4>
                <p className="text-gray-200">
                  On marketing that doesn't work. Every dollar you spend on advertising actually brings results.
                </p>
              </div>

              <div className="bg-white/5 rounded-lg p-6">
                <h4 className="text-lg font-semibold mb-3">You sleep better</h4>
                <p className="text-gray-200">
                  Knowing your business is growing steadily, attracting the right customers, building the legacy you intended.
                </p>
              </div>
            </div>

            <div className="mt-8 p-6 bg-[#A8AE9C]/20 rounded-lg border border-[#A8AE9C]/30">
              <p className="text-lg font-medium text-center">
                "This isn't about getting rich quick. This is about building something that wasn't there before."
              </p>
            </div>
          </div>
        </div>

        <div className="text-center">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 max-w-4xl mx-auto border border-white/20">
            <h3 className="text-2xl font-semibold mb-4 text-[#A8AE9C]">
              The real transformation isn't just financial
            </h3>
            <p className="text-lg text-gray-200 leading-relaxed">
              It's the confidence that comes from knowing your words finally match your work. 
              It's the pride of building something meaningful. It's the peace of mind that comes from sustainable, 
              profitable growth—not just another month of wondering if you'll make it.
            </p>
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default TransformationSection;
